import { useEffect } from 'react';
import type { Theme } from './types';

export function useTheme() {
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") as Theme | null;
    const theme = savedTheme || "light";
    
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, []);

  // Listen for storage changes (when theme is changed in another tab/window)
  useEffect(() => {
    const handleStorageChange = () => {
      const savedTheme = localStorage.getItem("theme") as Theme | null;
      const theme = savedTheme || "light";
      
      if (theme === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
}

